module.exports = __webpack_public_path__ + "img/nav-wishlist@2x.031b23b.webp";